import { get, post } from '.';

export function MatchOrCreateBaseDashboardSummary(options = {}) {
	return post<any>("/app/api/base_dashboard_summaries/match_or_create", options);
}

export function GetCurrentBaseDashboardSummaryForSharedLink(options = {}) {
    return get<any>("/app/api/base_dashboard_summaries/current_for_shared_link", options);
}